import React from 'react';
import Spinner from "../Spinner/Spinner";
import {Checkbox} from "semantic-ui-react";
import './SpinnerCheckBox.css'

class SpinnerCheckBox extends React.Component{
  render(){
    return(
      <div className="spinnerCheckBoxHolder">
        {
          this.props.hide ? null :
            <Checkbox checked={this.props.check} className="spinnerCheckBox" onChange={this.props.onCheckBoxChange}/>
        }
        {
          this.props.isColor ?
            <Spinner size={30} color={this.props.color ? this.props.color : '#0085ca'}/>
            :
            null
        }

      </div>
    )
  }
}

export default SpinnerCheckBox;
